<template>
  <f7-page>
    <f7-navbar back-link="back">
      <f7-nav-title>
        <navbar-center>
          <div slot="title">草稿複製</div>
          <div slot="subtitle">{{ menuDraftVariationProp }}</div>
        </navbar-center>
      </f7-nav-title>
    </f7-navbar>

    <f7-list>
      <f7-list-item title="複製至" group-title />
      <f7-list-item
        v-for="(store, index) in stores"
        :key="`release-stores-${index}`"
        radio
        :value="store.id"
        :title="`${store.name}${store.branch === null ? '' : store.branch}`"
        :after="storeId === store.id ? '目前店家' : ''"
        name="stores"
        :checked="targetStoreId === store.id"
        @change="setSelectedStoreId($event.target.value)" />
    </f7-list>

    <f7-button fill raised style="margin: 10%;" @click="copyMenu">複製</f7-button>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NavbarCenter from '@/common/components/NavbarCenter'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      targetStoreId: this.storeIdProp
    }
  },
  created () {
    this.getAllUserStores(this.uid)
  },
  computed: {
    ...mapState('userModule', ['uid', 'stores']),
    ...mapState('menuDraftModule', ['currentDraft']),
    ...mapGetters(['storeId']),
    targetStoreName () {
      const targetStore = this.stores.find(store => store.id === this.targetStoreId)
      return `${targetStore.name}${targetStore.branch === null ? '' : targetStore.branch}`
      // return targetStore.name + targetStore.branch
    }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('userModule', ['getAllUserStores']),
    ...mapActions('menuDraftModule', ['getMenuDraftList']),
    async setSelectedStoreId (storeId) {
      this.targetStoreId = storeId
    },
    copyMenu () {
      this.$f7.dialog.confirm(`是否複製 "${this.menuDraftVariationProp}" 至 ${this.targetStoreName}`, '複製草稿', async () => {
        this.$f7.dialog.progress('正在複製菜單，請稍待...')
        const timoutId = setTimeout(() => {
          this.$utils.nextFrame(() => this.$f7.dialog.close())
          this.$f7.dialog.alert('請檢查網路狀況', '無法複製菜單')
        }, 5000)
        try {
          await storeClient.post(`/stores/${this.storeIdProp}/menus/drafts/${this.menuDraftVariationProp}/copy`, {
            target: this.targetStoreId
          })
          this.$f7.dialog.alert('已複製', '成功', () => {
            this.getMenuDraftList()
            this.$f7router.back()
          })
        } catch (e) {
          console.error(e)
          this.$f7.dialog.alert('請檢查網路狀況', '無法複製草稿')
        } finally {
          clearTimeout(timoutId)
          this.$utils.nextFrame(() => this.$f7.dialog.close())
        }
      })
    }
  },
  components: {
    NavbarCenter
  }
}
</script>
